'use strict';

const { h } = require('phy');

const Carousel = require('../../../components/carousel');
const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');

const { pruneData } = require('../../support/prune-data');

function SideBar({ advertsForCarousel, routes, isTouch }) {
  return [
    Carousel({
      routes: pruneData(routes, 'merchant:show'),
      items: advertsForCarousel,
      isTouch,
    }),
    h(SidebarBrowseLetter, { routes }),
  ];
}

module.exports = SideBar;
